import tippy from 'tippy.js';
import { icons } from '../../../dist/svg/icon-set.js';

document.addEventListener('alpine:init', () => {
  Alpine.data('iconSet', () => ({
    icons,
    init() {
      tippy('.c-tooltip-icon');
    },
    copyContent(icon) {
      const el = document.createElement('textarea');
      el.value = `<i class="c-icon icon-${icon}" aria-hidden="true">{{ icon("${icon}") }}</i>`;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
  }))
});
